import { useState } from 'react';
import { CircularProgress, Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useModals } from '../../hooks/useModal';
import { useSwaggerClient } from '../../hooks/useSwaggerClient';
import EmaillogTable from '../../pages/admin/emaillogs/EmaillogTable';

function GuestEmaillogTable({ guestId }) {
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(0);
    const { currentlyShowingModal } = useModals();

    const [data, loading, error] = useSwaggerClient(
        'emaillogs',
        'getEmaillogsPerGuest',
        {
            page,
            pageSize,
            id: guestId
        },
        // to trigger rerender
        [currentlyShowingModal]
    );

    if (error) {
        return (
            <Grid container justifyContent="center">
                <Alert className="mt-2" severity="error">
                    <h4>{error.response.body.message}</h4>
                </Alert>
            </Grid>
        );
    }

    return (
        <Grid container className="mt-2">
            <Grid item style={{ paddingLeft: '12px' }}>
                <h2>Emails</h2>
            </Grid>
            {loading && data?.length === 0 ? (
                <Grid item xs={12}>
                    <CircularProgress />
                </Grid>
            ) : (
                <EmaillogTable
                    total={data?.count}
                    emails={data?.logs}
                    page={page}
                    pageSize={pageSize}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    columnsToShow={['created_at', 'subject', 'type', 'status', 'result', 'actions']}
                />
            )}
        </Grid>
    );
}

export default GuestEmaillogTable;
